export default __webpack_public_path__ + "static/media/Onest-Regular.294614c4.woff2";